import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import TicketChat from "./components/TicketChat";
import SupportModal from "./modals/NewTicketModal";
import CargoService from "../../../services/Cargo";
import { timeAgo, gregorianToJalali } from "../../../utiels/functions/persianFormat";
import EmptyStateMyLoads from "../../../Modals/empty list/EmptyList";
import { MdOutlineMessage } from "react-icons/md";
import SupportSkeleton from "../../rent/dashboard/Support/SupportSkeleton";


export default function SupportContent() {
    const [expanded, setExpanded] = useState({});
    const [selectedTicket, setSelectedTicket] = useState(null);
    const [openTicket, setOpenTicket] = useState(false);
    const [allTicket, setAllTicket] = useState([])
    const [highlightSupportButton, setHighlightSupportButton] = useState(false);
    const [answered, setAnswered] = useState(false)
    const [loading, setLoading] = useState(false)

    const toggleExpand = (id) => {
        setExpanded((prev) => ({ ...prev, [id]: !prev[id] }));
    };

    // بازگشت به لیست
    // const handleBackToList = () => {
    //     setSelectedTicket(null);
    // };
    const handleBackToList = () => {
        setSelectedTicket(null);
        setHighlightSupportButton(false);
    };


    async function getAllTicket() {
        setLoading(true);
        try {
            const params = {
                // "answered": answered,
                "role": "user",
            }
            const res = await CargoService.getTicket(params)
            setAllTicket(res?.data?.message)

        } catch (err) {
            console.log(err)
        }
        finally {
            setLoading(false);
        }
    }
    useEffect(() => {
        getAllTicket()
    }, [])

    if (loading) return <SupportSkeleton />

    return (
        <>
            {
                allTicket?.length == 0 ?
                    <>
                        <EmptyStateMyLoads

                            colorContent="text-special"
                            title="پیامی برای نمایش وجود ندارد"
                            subtitle="تاکنون تیکتی ثبت نکرده اید."
                            onCta={() => { setOpenTicket(true) }}
                            icon={MdOutlineMessage}
                            ctaText="افزودن تیکت جدید" >

                        </EmptyStateMyLoads>

                        <SupportModal
                            isOpen={openTicket}
                            onClose={() => setOpenTicket(false)}
                            onSend={(msg) => console.log("پیام پشتیبانی:", msg)}
                            render={getAllTicket}
                        />
                    </>


                    :


                    <div className="flex flex-col items-start justify-start w-full lg:h-[calc(100vh-10rem)] h-[80vh] overflow-y-auto">
                        <div className="flex justify-start ms-4 lg:ms-0 mb-5 gap-3">
                            <button
                                onClick={() => setOpenTicket(true)}
                                className={`px-6 py-1 border rounded-2xl transition 
                                ${highlightSupportButton
                                        ? "bg-special text-white border-blue-700"
                                        : "bg-white text-gray-400 border-gray-400 hover:bg-gray-200 hover:text-black"
                                    }`} >
                                پیام به پشتیبانی
                            </button>
                            <button
                                className={`px-6 py-1 border rounded-2xl transition 
                    ${selectedTicket
                                        ? "bg-white text-gray-400 border-gray-400 hover:bg-gray-300"
                                        : "bg-special text-white border-gray-400 hover:text-black hover:bg-gray-200"
                                    }`}
                                onClick={handleBackToList}
                                disabled={!selectedTicket}
                            >
                                لیست تیکت ها
                            </button>
                        </div>


                        {selectedTicket ? (
                            <TicketChat ticket={selectedTicket} onBack={handleBackToList} />
                        ) : (

                            <>
                                {allTicket.map((msg, index) => {
                                    const isExpanded = expanded[msg.id];
                                    const textLimit = 120;

                                    return (
                                        <motion.div
                                            key={msg.id}
                                            initial={{ opacity: 0, y: 20 }}
                                            animate={{ opacity: 1, y: 0 }}
                                            transition={{ duration: 0.4, delay: index * 0.1 }}
                                            className="flex flex-col w-full border-b border-gray-300 py-5"
                                            dir="rtl"
                                        >


                                            <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center mb-3">
                                                <div className="flex items-center gap-3">
                                                    <h2 className="font-bold text-secondary text-lg">
                                                        موضوع: {msg.subject}
                                                    </h2>
                                                </div>
                                                <p className="text-[#6B7280] text-sm mt-1 sm:mt-0">
                                                    تاریخ: {gregorianToJalali(msg.createdAt)}
                                                </p>
                                            </div>


                                            {/* <p className="text-[#6B7280] text-base leading-7 m-0 break-words">
                                    {isExpanded || msg.text.length <= textLimit
                                        ? msg.text
                                        : (
                                            <>
                                                {msg.text.slice(0, textLimit) + "..."}
                                                {msg.text.length > textLimit && (
                                                    <button
                                                        onClick={() => toggleExpand(msg.id)}
                                                        className="text-blue-600 text-sm hover:underline whitespace-nowrap align-baseline ml-2"
                                                        style={{ direction: 'rtl', display: 'inline', padding: 0, background: 'none' }}
                                                    >
                                                        {isExpanded ? "نمایش کمتر" : "نمایش بیشتر"}
                                                    </button>
                                                )}
                                            </>
                                        )}
                                    {isExpanded && msg.text.length > textLimit && (
                                        <button
                                            onClick={() => toggleExpand(msg.id)}
                                            className="text-blue-600 text-sm hover:underline whitespace-nowrap align-baseline ml-2"
                                            style={{ direction: 'rtl', display: 'inline', padding: 0, background: 'none' }}
                                        >
                                            نمایش کمتر
                                        </button>
                                    )}
                                </p> */}

                                            {/* دکمه جزئیات */}
                                            <div className="mt-2 flex">
                                                <button
                                                    onClick={() => {
                                                        setSelectedTicket(msg);
                                                        setHighlightSupportButton(true); // ✅ رنگ پیام به پشتیبانی عوض می‌شود
                                                    }}
                                                    className="text-white bg-special w-full sm:w-[150px] h-[35px] rounded-xl hover:bg-blue-700 text-sm"
                                                >
                                                    جزئیات بیشتر
                                                </button>
                                            </div>
                                        </motion.div>
                                    );
                                })}
                            </>
                        )}


                        <SupportModal
                            isOpen={openTicket}
                            onClose={() => setOpenTicket(false)}
                            onSend={(msg) => console.log("پیام پشتیبانی:", msg)}
                            render={getAllTicket}
                        />
                    </div>
            }

        </>
    );
}
